import { FC, useState } from 'react';

import { IconProps } from '../../shared/ui';

export const MeetChatIcon: FC<IconProps> = ({ width = 48, height = 48, className, checked }) => {
  const [hover, setHover] = useState(false);

  const fill = checked ? '#2C3038' : hover ? '#6F6F6F' : '#828282';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`hover:cursor-pointer ${className ?? ''}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <title>Чат</title>
      <rect width="48" height="48" rx="10" fill={fill} />
      <path
        d="M14 15C12.8954 15 12 15.8954 12 17V27C12 28.1046 12.8954 29 14 29H20.1716L24.4142 33.2426C24.7893 33.6177 25.3787 33.6177 25.7538 33.2426L30 29H34C35.1046 29 36 28.1046 36 27V17C36 15.8954 35.1046 15 34 15H14Z"
        fill="white"
      />
    </svg>
  );
};
